import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Kesco_PaymentFields from './PaymentBoxes/Kesco_PaymentFields';
import Policia_PaymentFields from './PaymentBoxes/Policia_PaymentFields';
import Bks_PaymentFields from './PaymentBoxes/Bks_PaymentFields';
import Atk_PaymentFields from './PaymentBoxes/Atk_PaymentFields';
import KruPrishtina_PaymentFields from './PaymentBoxes/KruPrishtina_PaymentFields';
import KruHidroregjinoiJugor_PaymentFields from './PaymentBoxes/KruHidroregjinoiJugor_PaymentFields';
import KruHidrodrini_PaymentFields from './PaymentBoxes/KruHidrodrini_PaymentFields';
import Uniref_PaymentFields from './PaymentBoxes/Uniref_PaymentFields';
import { useNavigate } from 'react-router-dom';
import Home from './Home';
import Komunat_PaymentFields from './PaymentBoxes/Komunat_PaymentFields';
import E_sim_PaymentFields from './PaymentBoxes/E_Sim_PaymentFields';
import Vala_PaymentFields from './PaymentBoxes/Vala_PaymentFields';
import PrishtinaParking_PaymentFields from './PaymentBoxes/PrishtinaParking_PaymentFields';
import Dogana_PaymentFields from './PaymentBoxes/Dogana_PaymentFields';

const PaymentFields = () => {
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const navigate = useNavigate();

    useEffect(() => {
        if (!SelectedPayment.component) {
            navigate("/");
        }
    }, [SelectedPayment, navigate]);

    return (
        <Fragment>
            {SelectedPayment.component === 'kesco' ? (
                <Kesco_PaymentFields />
            ) : SelectedPayment.component === 'police' ? (
                <Policia_PaymentFields />
            ) : SelectedPayment.component === 'bks' ? (
                <Bks_PaymentFields />
            ) : SelectedPayment.component === 'atk' ? (
                <Atk_PaymentFields />
            ) : SelectedPayment.component === 'kru-pr' ? (
                <KruPrishtina_PaymentFields />
            ) : SelectedPayment.component === 'kru-jugor' ? (
                <KruHidroregjinoiJugor_PaymentFields />
            ) : SelectedPayment.component === 'hidrodrini' ? (
                <KruHidrodrini_PaymentFields />
            ) : SelectedPayment.component === 'uniref' ? (
                <Uniref_PaymentFields />
            ) : SelectedPayment.component === 'komunat' ? (
                <Komunat_PaymentFields />
            ) : SelectedPayment.component === 'vala' ? (
                <Vala_PaymentFields />
            ) : SelectedPayment.component === 'prishtina-parking' ? (
                <PrishtinaParking_PaymentFields />
            ) : SelectedPayment.component === 'dogana' ? (
                <Dogana_PaymentFields />
            ) : (
                <Home />
            )}
        </Fragment>
    )
}

export default PaymentFields